export const NEWRELIC_MONITORING_ENABLED = process.env['NEXT_PUBLIC_NEWRELIC_MONITORING_ENABLED'] === 'true';
export const NEWRELIC_BEACON = process.env['NEXT_PUBLIC_NEWRELIC_BEACON'];
export const NEWRELIC_LICENSE_KEY = process.env['NEXT_PUBLIC_NEWRELIC_LICENSE_KEY'];
export const NEWRELIC_APPLICATION_ID = process.env['NEXT_PUBLIC_NEWRELIC_APPLICATION_ID'];
export const NEWRELIC_ACCOUNT_ID = process.env['NEXT_PUBLIC_NEWRELIC_ACCOUNT_ID'];
